import {SurchargeDefinitionPage} from "./SurchargeDefinition/SurchargeDefinitionPage.tsx";
import {SurchargeGroupConfiguration} from "./SurchargeDefinition/SurchargeGroup/SurchargeGroupConfiguration.tsx";

export const ConfigPage = () => {
    return <>
        <h1>Configuration</h1>
        <SurchargeGroupConfiguration/>
        <SurchargeDefinitionPage/>
    </>


}